<div class="delete-container">
  <div class="delete-container__header">
    <div class="delete-container__header-title">Delete delivery service?</div>
    <div class="close-icon">
      <img alt="" (click)="onClose()" src="../.././../../../assets/icons/x-delivery-services.svg" />
    </div>
  </div>
  <div class="text">
    <div class="delete-container__text">You're deleting delivery service '{{carrierName}}'.</div>
    <div class="delete-container__text">Are you sure?</div>
  </div>

  <div class="delete-container__actions">
    <pdq-button variant="danger" (onClick)="onDeleteClicked()">Delete</pdq-button>
    <pdq-button (onClick)="onClose()">Cancel</pdq-button>
  </div>
</div>
